export default "__VITE_ASSET__fb55cfa6__"